import { useQuery } from "@tanstack/react-query"
import toast from "react-hot-toast"
import axiosInstance from "@/services/axiosInstance"

const instance = axiosInstance()

export async function getContractHistory(solicitation_id) {
  const response = await instance.get(`/contract/get_contract_history/${solicitation_id}`)
  return response.data
}

export function useContractHistory(solicitation_id) {
  return useQuery({
    queryKey: ["contract-history", solicitation_id],
    queryFn: async () => {
      return getContractHistory(solicitation_id)
    },
    enabled: !!solicitation_id,
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail)
      else toast.error(e.message)
    },
  })
}
